<template>
    <DefaultHeader />
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-12 col-md-6 d-flex flex-column vh-auto h-100">
                <BadgeCard :badge="badge"/>
            </div>



            <div class="col-12 col-md-6 d-flex flex-column">

                <ul class="nav nav-tabs bg-light rounded-top border border-1">
                    <li class="nav-item">
                        <div role="button" v-on:click="tab = 1"
                            :class="{ active: tab == 1, 'text-decoration-underline': tab == 1 }" class="nav-link"
                            aria-current="page" href="#">Dernières utilisations</div>
                    </li>
                    <li class="nav-item">
                        <div role="button" v-on:click="tab = 2"
                            :class="{ active: tab == 2, 'text-decoration-underline': tab == 2 }" class="nav-link"
                            href="#">Véhicules autorisés</div>
                    </li>
                </ul>

                <!-- Badge alarms list -->
                <div v-if="this.tab == 1" class="card shadow bg-white">
                    <div class="table-responsive p-3">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">Date</th>
                                    <th scope="col">Adresse</th>
                                    <th scope="col" class="text-end">Véhicule</th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr v-for="(alarm, index) in alarms" :key="index">
                                    <td>
                                        {{ alarm.date }}
                                    </td>
                                    <td>
                                        {{ alarm.address }}
                                    </td>
                                    <td>
                                        <VehicleNameDisplay :balise="alarm.balise"/>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <div class="card-footer p-3 text-center">
                        <RouterLink :to="'/badgealarmslist/' + this.$route.params.id">Voir toutes les données</RouterLink>
                    </div>
                </div>

                <!-- Vehicles list -->
                <div v-if="tab == 2" class="card shadow bg-white">
                    <div class="table-responsive p-3">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">Dernière utilisation</th>
                                    <th scope="col">Véhicules</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(vehicle, index) in allowedVehicles" :key="index">
                                    <td v-if="vehicle.alarms != null && vehicle.alarms.length > 0">{{ vehicle.alarms[0].date }}</td>
                                    <td v-else>Jamais utilisé</td>
                                    <td><VehicleNameDisplay :balise="vehicle"/></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <DefaultFooter />
</template>

<script>
import DefaultHeader from '@/components/DefaultHeader.vue'
import DefaultFooter from '@/components/DefaultFooter.vue'
import BadgeService from '@/services/badge.service.js'
import AlarmService from '@/services/alarm.service.js'
import BaliseService from '@/services/balise.service.js'
import FormatHelper from '@/helpers/format.helper.js'
import BadgeCard from '@/components/display/BadgeCard.vue'
import VehicleNameDisplay from '@/components/display/VehicleNameDisplay.vue'


export default {
    components: {
        DefaultHeader,
        DefaultFooter,
        VehicleNameDisplay,
        BadgeCard
    },
    data() {
        return {
            badge: null,
            alarms: null,
            allowedVehicles: null,
            tab: 1,
        };
    },
    mounted() {
        this.refreshData();
    },
    methods: {
        refreshData() {
            BadgeService.getBadge(this.$route.params.id)
            .then(response => {

                this.badge = FormatHelper.badgeInfoFormat(response.data);

                AlarmService.getBadgeAlarms(this.badge.number, 0, 10)
                .then(response => {
                    this.alarms = FormatHelper.baliseAlertsFormat(response.data.rows);
                })
                .catch(e => {
                    console.log(e);
                });

                BaliseService.getBadgeBalises(this.badge.number)
                .then(response => {
                    this.allowedVehicles = FormatHelper.balisesResponseFormat(response.data);
                })
                .catch(e => {
                    console.log(e);
                });
            })
            .catch(e => {
                console.log(e);
            });
        }
    }
}
</script>

<style>
.gradient-custom {
    /* fallback for old browsers */
    background: #f6d365;

    /* Chrome 10-25, Safari 5.1-6 */
    background: -webkit-linear-gradient(to right bottom, #e4ae6d, #f06322);

    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background: linear-gradient(to right bottom, #e4ae6d, #f06322)
}
</style>